module.exports = __webpack_public_path__ + "static/media/steph.864c7f9f.jpg";